/**
 * Base64url (RFC 4648 §5) helpers used by the WebAuthn ceremony adapter.
 * Trailing `=` padding is stripped on encode; both padded and unpadded inputs
 * are accepted on decode.
 */

/** Encode a Uint8Array or ArrayBuffer as a base64url string (no padding). */
export function bytesToB64u(input: Uint8Array | ArrayBuffer): string {
  const bytes = input instanceof Uint8Array ? input : new Uint8Array(input);
  let bin = '';
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  const b64 = btoa(bin);
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** Decode a base64url string into a Uint8Array. Padding is optional. */
export function b64uToBytes(s: string): Uint8Array {
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/');
  const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
  const bin = atob(padded); // throws DOMException on invalid input — correct behavior
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
